// Placeholder Home after unlock (I-1a Batch 4). The real Home (S01, icon matrix)
// comes with I-1b. Shows, once, the failed tries since the last unlock as a
// count without times (Tool Plan §4.15, IR-22; S27 later), says when another
// window is the writer or the diary is read-only for a version reason (failed
// migration, newer data; I-1a Batch 7), says calmly when storage is full
// (writing stopped; I-1a Batch 6c), and offers "Backup & move" (S33, I-1a
// Batch 6b) and "Lock now".

import type { ReadOnlyReason } from '../lock'
import { ScreenTitle } from '../ui/ScreenTitle'

import { backup, home, PRODUCT_NAME } from './copy'

const READ_ONLY_TEXT: Readonly<Record<ReadOnlyReason, string>> = {
  'other-copy-open': home.readOnly,
  'migration-failed': home.migrationFailed,
  'newer-data': home.newerData,
}

interface HomePlaceholderProps {
  readonly failedTries: number
  readonly readOnlyReason: ReadOnlyReason | null
  readonly storageFull: boolean
  readonly onBackup: () => void
  readonly onLock: () => void
}

export function HomePlaceholder({
  failedTries,
  readOnlyReason,
  storageFull,
  onBackup,
  onLock,
}: HomePlaceholderProps): React.JSX.Element {
  return (
    <section className="screen">
      <div className="screen__body">
        <ScreenTitle>{PRODUCT_NAME}</ScreenTitle>
        <p className="screen__text">{home.text}</p>
        {failedTries > 0 ? <p className="notice">{home.failedTries(failedTries)}</p> : null}
        {readOnlyReason ? <p className="notice">{READ_ONLY_TEXT[readOnlyReason]}</p> : null}
        {storageFull ? <p className="notice">{home.storageFull}</p> : null}
        <div className="actions">
          <button type="button" className="button button--quiet" onClick={onBackup}>
            {backup.open}
          </button>
          <button type="button" className="button button--quiet" onClick={onLock}>
            {home.lockNow}
          </button>
        </div>
      </div>
    </section>
  )
}
